<div class="container">
  <div class="title" i18n="@@specialMentions-title">Mentions spéciales</div>
  <app-player-mention-widget *ngIf="soleWinner" [player]="soleWinner" mention="winner"></app-player-mention-widget>
  <app-player-mention-widget *ngIf="soleLoser" [player]="soleLoser" mention="loser"></app-player-mention-widget>
  <app-player-mention-widget *ngIf="fastest" [player]="fastest" [result]="fastestResult" mention="fastest"></app-player-mention-widget>
  <app-player-mention-widget *ngIf="slowest && (slowest.id !== fastest?.id)" [player]="slowest" [result]="slowestResult" mention="slowest"></app-player-mention-widget>
</div>
